import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryTemplatePresetRepository } from '@/coreInfrastructureModule/interfaces/IInventoryTemplatePresetRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 出力条件プリセットを削除するユースケース
 */
export class DeleteInventoryTemplatePresetUseCase {
  /**
   * コンストラクタ
   * @param repository - 出力条件プリセットを削除するリポジトリ
   */
  constructor(private readonly repository: IInventoryTemplatePresetRepository) {}

  /**
   * プリセットを削除する
   * @param presetId - プリセットID
   */
  public Execute = async (presetId: string): Promise<INetworkResult<void, IError>> => {
    const result = await this.repository.delete(presetId);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    }

    return { status: result.status };
  };
}
